import CustomStore, { CustomStoreOptions } from "devextreme/data/custom_store";
import { useMemo, useRef } from "react";
import { apiClient } from "../lib/api-client";

export interface RemoteDataSourceOptions extends CustomStoreOptions {
	unfilteredTotalCount: () => number;
}

export class RemoteDataSource extends CustomStore {

	constructor(options: RemoteDataSourceOptions) {
		super(options);

		this.unfilteredTotalCount = options?.unfilteredTotalCount;
	}

	unfilteredTotalCount: () => number;
}

export function useRemoteDataSource(key: string, url: string, params: any, enabled?: boolean) {

	const totalCount = useRef<number>();
	const unfilteredTotalCount = useRef<number>();

	return useMemo(() => {
		if (!(enabled ?? true))
			return [];

		return new RemoteDataSource({
			key: key,
			loadMode: "processed",
			load: (loadOptions: any) => {
				return apiClient.post(url, { ...params, loadOptions: loadOptions });
			},
			onLoaded: (result: any) => {
				if (result.totalCount >= 0) {
					totalCount.current = result.totalCount;
				}

				if (result.unfilteredTotalCount >= 0) {
					unfilteredTotalCount.current = result.unfilteredTotalCount;
				}
			},
			totalCount: (loadOptions) => {
				return new Promise((resolve, reject) => {
					return resolve(totalCount.current ?? -1);
				});
			},
			unfilteredTotalCount: () => {
				return unfilteredTotalCount.current ?? 0;
			}
		});
	}, [key, url, params, enabled]);
}